import React, { useState, useEffect } from "react";
import "./Activities.scss";
import useFadeIn from "../hooks/useFadeIn";
import { formatAmount, startingPrice } from "./activityPrice";

const BACKEND = process.env.REACT_APP_BACKEND;

// Individual Card Component to manage its own state
function ActivityCard({ activity, index = 0 }) {
  const [isFlipped, setIsFlipped] = useState(false);
  const ref = useFadeIn(index * 80);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleFlip();
    }
  };

  const prices = activity.prices || [];
  const badge = startingPrice(prices);

  return (
    <div
      ref={ref}
      className="activity-card-container fade-in"
      onClick={handleFlip}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={isFlipped}
      aria-label={`${activity.name}, show ${isFlipped ? "photo" : "details and prices"}`}
    >
      <div className={`activity-card-inner ${isFlipped ? "is-flipped" : ""}`}>
        {/* --- FRONT FACE --- */}
        <div className="activity-card-face activity-card-front">
          <div className="image-container">
            <img
              src={`${BACKEND}/images/activities/${activity.image}`}
              alt={activity.name}
              loading="lazy"
            />
            {badge && (
              <span className="price-badge">
                {badge.isFrom && <small>From</small>}
                {formatAmount(badge)}
                {!badge.isFrom && badge.unit && <small>/ {badge.unit}</small>}
              </span>
            )}
          </div>
          <div className="front-caption">
            <h2>{activity.name.trim()}</h2>
            <span className="flip-hint">
              Details <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
            </span>
          </div>
        </div>

        {/* --- BACK FACE --- */}
        <div className="activity-card-face activity-card-back">
          <div className="back-header">
            <h2>{activity.name.trim()}</h2>
            <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
          </div>

          <p className="description">{activity.description.trim()}</p>

          <div className="price-block">
            {prices.length > 0 ? (
              <ul className="price-list">
                {prices.map((p, i) => (
                  <li key={i}>
                    <span className="price-label">{p.label}</span>
                    <span className="price-value">
                      {formatAmount(p)}
                      {p.unit && <small> / {p.unit}</small>}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              activity.price && <p className="price-legacy">{activity.price.trim()}</p>
            )}
            {activity.priceNote && (
              <p className="price-note">
                <i className="fa-solid fa-circle-info" aria-hidden="true"></i>
                {activity.priceNote}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


// Main Activities Component
function Activities() {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    fetch(`${BACKEND}/api/activities`)
      .then((r) => r.json())
      .then(setActivities)
      .catch(console.error);
  }, []);

  return (
    <div className="activity-list-container">
      {activities.map((activity, i) => (
        <ActivityCard activity={activity} index={i} key={activity._id} />
      ))}
    </div>
  );
}

export default Activities;